var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 10,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15C14.25 15 13.6079 14.7329 13.0738 14.1988C12.5397 13.6648 12.2727 13.0227 12.2727 12.2727C12.2727 11.5227 12.5397 10.8807 13.0738 10.3466C13.6079 9.81249 14.25 9.54544 15 9.54544C15.75 9.54544 16.392 9.81249 16.9261 10.3466C17.4602 10.8807 17.7272 11.5227 17.7272 12.2727C17.7272 13.0227 17.4602 13.6648 16.9261 14.1988C16.392 14.7329 15.75 15 15 15ZM10.909 20.4545C10.534 20.4545 10.2131 20.3211 9.94632 20.0543C9.67905 19.787 9.54541 19.4659 9.54541 19.0909V18.5454C9.54541 18.1591 9.64496 17.8038 9.84405 17.4798C10.0427 17.1561 10.3068 16.9091 10.6363 16.7386C11.3409 16.3863 12.0568 16.122 12.784 15.9457C13.5113 15.7698 14.25 15.6818 15 15.6818C15.75 15.6818 16.4886 15.7698 17.2159 15.9457C17.9431 16.122 18.659 16.3863 19.3636 16.7386C19.6931 16.9091 19.9572 17.1561 20.1559 17.4798C20.355 17.8038 20.4545 18.1591 20.4545 18.5454V19.0909C20.4545 19.4659 20.3211 19.787 20.0543 20.0543C19.787 20.3211 19.4659 20.4545 19.0909 20.4545H10.909Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFilled);
export default __webpack_public_path__ + "static/media/person-filled.d058b345.svg";
export { ForwardRef as ReactComponent };